<template>
	<div v-if="type == 'time'" class="c-datetime flex-center">
		<el-time-picker v-model="valueData" :is-range="range" :placeholder="placeholder" :value-format="valueFormat" @change="changeHandle"></el-time-picker>
	</div>
	<div v-else class="c-datetime" :warn="!!(name || startName || endName) && warnState" @click="cFormItemStore.commit('warnState', false)">
		<el-date-picker v-model="valueData" :type="compType" :placeholder="placeholder" :value-format="valueFormat" unlink-panels :default-time="range ? ['00:00:00', '23:59:59'] : undefined" @change="changeHandle"></el-date-picker>
	</div>
</template>

<script>
	import {getStore, mapStore} from '@deanwu/vue-component-library'
	
	export default {
		name: 'cDatetime',
		
		props: {
			value: [String, Array],
			name: String,
			startName: String,
			endName: String,
			type: {
				type: String,
				default: 'datetime'
			},
			format: String,
			range: Boolean,
			placeholder: String
		},

		data() {
			return {
				...getStore(this, 'cFormItemStore'),
				valueData: this.value
			}
		},
		
		computed: {
			...mapStore('cFormItemStore', ['warnState']),

			compType() {
				return `${this.type}${this.range ? 'range' : ''}`;
			},
			
			valueFormat() {
				if (this.format) return this.format;

				switch (this.type) {
				case 'datetime':
					return 'yyyy-MM-dd HH:mm:ss';
					
				case 'date':
					return 'yyyy-MM-dd';
					
				case 'time':
					return 'HH:mm:ss';
				}
				
				return '';
			}
		},
		
		watch: {
			value(val) {
				this.set(val);
			},
			
			valueData() {
				this.$emit('input', this.get());
			}
		},
		
		methods: {
			set(val = '') {
				this.valueData = val;
			},
			
			get() {
				return this.valueData;
			},

			changeHandle() {
				this.$emit('change', this.get());
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.c-datetime {
		box-sizing: border-box;
		width: 100%;
		height: 38px;
		border: 1px solid var(--unit-border);
		background: #fff;
		transition: border .3s ease;

		&[warn] {
			border-color: var(--unit-warn) !important;
		}
		
		&:not(.z-dis):not(:focus-within):hover {
			border-color: var(--unit-hover-border);
		}
				
		&:focus-within {
			border-color: var(--unit-active-border);
		}
		
		>>> .el-date-editor {
			display: flex;
			align-items: center;
			width: 100%;
			height: 100%;
			border: none !important;
			background: none !important;
			
			.el-input__inner {
				flex-grow: 1;
				height: 100%;
				border: none;
				padding: 0 0 0 10px;
				color: #000;
				background: none;
			}
			
			.el-input__prefix,
			.el-icon-date {
				display: none !important;
			}
			
			.el-input__suffix {
				right: 0;
			}
			
			.el-input__icon {
				display: flex;
				align-items: center;
				justify-content: center;
				min-width: 28px;
			}
		}
		
		>>> .el-range-editor {
			display: flex;
			align-items: center;
			height: 100%;
			border-radius: 0;
			font-size: 0;
			transition: all .3s ease;
				
			&.is-active {
				border-color: var(--unit-hover-border);
			}
				
			&.el-input__inner {
				padding: 0 0 0 10px;
			}
			
			.el-range-input {
				flex-grow: 1;
				height: 100%;
				font-size: 14px;
				text-align: left;
				color: #000;
			}
			
			.el-range-separator {
				vertical-align: top;
				height: auto;
				margin-bottom: 4px;
				line-height: normal;
				color: #aaa;
			}
		}
			
		>>> .el-input__icon {
			line-height: normal;
			
			&.el-icon-time {
				display: none;
			}
			
			&.el-range__close-icon {
				display: flex;
				align-items: center;
				justify-content: center;
				min-width: 28px;
			}
			
			&:not(.el-icon-circle-close) {
				&:before {
					content: '\e688';
					font-family: 'c-icon' !important;
					font-size: 14px;
					font-style: normal;
					color: #999;
				}
			}
			
			&.el-icon-circle-close {
				&:hover:before {
					color: #333;
				}
				
				&:before {
					content: '\e646';
					font-family: 'c-icon' !important;
					font-size: 16px;
					font-style: normal;
					color: #999;
				}
			}
		}
	}
</style>